/**
 * UK SIC 2007 descriptions for the construction section (41 to 43), the codes
 * the Companies House register import keeps. This is the published
 * classification itself, not company data, so it lives in code.
 * Safe to import anywhere.
 */

const CONSTRUCTION_SIC: Record<string, string> = {
  "41100": "Development of building projects",
  "41201": "Construction of commercial buildings",
  "41202": "Construction of domestic buildings",
  "42110": "Construction of roads and motorways",
  "42120": "Construction of railways and underground railways",
  "42130": "Construction of bridges and tunnels",
  "42210": "Construction of utility projects for fluids",
  "42220": "Construction of utility projects for electricity and telecommunications",
  "42910": "Construction of water projects",
  "42990": "Construction of other civil engineering projects n.e.c.",
  "43110": "Demolition",
  "43120": "Site preparation",
  "43130": "Test drilling and boring",
  "43210": "Electrical installation",
  "43220": "Plumbing, heat and air-conditioning installation",
  "43290": "Other construction installation",
  "43310": "Plastering",
  "43320": "Joinery installation",
  "43330": "Floor and wall covering",
  "43341": "Painting",
  "43342": "Glazing",
  "43390": "Other building completion and finishing",
  "43910": "Roofing activities",
  "43991": "Scaffold erection",
  "43999": "Other specialised construction activities n.e.c.",
};

/** The official description of a construction SIC code, or null for other codes. */
export function sicDescription(code: string): string | null {
  return CONSTRUCTION_SIC[code] ?? null;
}

/** "43210 (electrical installation)", or just the code when it is not a construction code. */
export function sicLabel(code: string): string {
  const description = sicDescription(code);
  return description ? `${code} (${description.charAt(0).toLowerCase()}${description.slice(1)})` : code;
}
